import React from 'react';
import classNames from 'classnames';

import UtilityCard from '../UtilityCard';

import styles from './InformationalCard.module.scss';

const { 'card-body': cardBodyClass, 'header-icon': headerIconClass, framed: framedClass } = styles;

const InformationalCard = props => {
  const {
    isBorderless = false,
    icon,
    title = '',
    body = '',
    ctaCopy = '',
    ctaHandler,
    customClass,
    customButtonClass
  } = props;
  const infoCardClasses = classNames(cardBodyClass, { [framedClass]: !isBorderless });

  return (
    <UtilityCard
      {...{ isBorderless, customClass, customButtonClass }}
      handleButtonClick={ctaHandler}
      buttonCopy={ctaCopy}
      buttonColor="white"
      buttonBorder="border-black"
    >
      <div className={infoCardClasses}>
        {icon && (
          <div className={headerIconClass}>
            <img src={icon} alt="informational icon" />
          </div>
        )}
        <h1>{title}</h1>
        <p>{body}</p>
      </div>
    </UtilityCard>
  );
};

export default InformationalCard;
